
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';

import { filter, map } from 'rxjs';
import { CountryNameService } from '../../../app/providers/country-name.service';
import { PageService } from '../../../app/providers/page.service';
import { SettingsService } from '../../../app/providers/settings.service';
import { isPageWithCountries } from '../../../app/types/page';

@Component({
    selector: 'app-translation-switch',
    templateUrl: './translation-switch.component.html',
    styleUrls: ['./translation-switch.component.scss'],
    imports: [RouterOrExternalLinkDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      '[class.hidden]': 'hidden',
    },
})
export class TranslationSwitchComponent {

  protected languageCodes?: string[];
  protected languageUrls?: { [languageCode: string]: string };
  protected isLocalContent?: boolean;

  private defaultText = 'Read the local part in your language';
  private localPartLabels?: { [language: string]: string };

  private countryNameService = inject(CountryNameService);

  protected get hidden() { return !(this.isLocalContent && this.languageCodes && this.languageUrls); }

  public constructor() {
    inject(PageService).page.pipe(
      filter(isPageWithCountries),
      map(page => {
        return {
          languageMap: Object.fromEntries(
            Object.entries(page.countryLanguageCombinations[page.currentCountry])
            .filter(([language]) => {
              return language !== page.currentLanguage;
            }),
          ),
          isCountryContent: page.isLocalContentPage,
        };
      }),
      takeUntilDestroyed(),
    ).subscribe((pageData) => {
      this.languageUrls = pageData.languageMap;
      this.languageCodes = Object.keys(pageData.languageMap).filter((languageCode) => languageCode !== 'en');
      this.isLocalContent = pageData.isCountryContent;
    });

    inject(SettingsService).localPartLabels.pipe(
      takeUntilDestroyed(),
    ).subscribe(value => this.localPartLabels = value);
  }

  protected getCountryCodeFromLanguageCode(languageCode: string) {
    return this.countryNameService.getCountryCodeFromLanguageCode(languageCode);
  }

  protected contentInYourLanguage(languageCode: string) {
    return this.localPartLabels
      && this.localPartLabels[languageCode] ? this.localPartLabels[languageCode] : this.defaultText;
  }

}
